import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanLoad, Router, RouterStateSnapshot, Route } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { defaultUserRoute } from '../config/routes.config';
import { isAppTaskPrivilege, isAppMasterTaskPrivilege, isSAPrivilege } from '../utils/jwt.utils';

@Injectable()
export class CalendarGuard implements CanActivate, CanLoad {
  constructor(
    private router: Router
  ) { }

  canActivate(
    _route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this.checkAccess();
  }

  canLoad(
    _route: Route
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this.checkAccess();
  }

  private checkAccess() {
    if (isAppTaskPrivilege() || isAppMasterTaskPrivilege() || isSAPrivilege()) {
      return true;
    } else {
      this.router.navigateByUrl(defaultUserRoute);
      return false;
    }
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/guards/calendar.guard.ts